/** @format */

import React, { useEffect, useState } from "react";
import Table from "../../extra/Table";
import { connect, useDispatch, useSelector } from "react-redux";
import { getAllAdmins, toggleAdminDisable } from "../../store/admin/admin.action";
import ToggleSwitch from "../../extra/ToggleSwitch";
import dayjs from "dayjs";
import Searching from "../../extra/Searching";
import Skeleton from "react-loading-skeleton";
import { colors } from "../../../util/SkeletonColor";
import "react-loading-skeleton/dist/skeleton.css";
import { baseURL } from "../../../util/config";
import { getImageUrl } from "../../../util/getImageUrl";

const AdminUsers = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState("");
	const { adminUsers } = useSelector((state) => state.admin);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getAllAdmins());
	}, [dispatch]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setLoading(false);
		}, 1500);
		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		setData(adminUsers);
	}, [adminUsers]);

	const handleToggle = (row) => {
		dispatch(toggleAdminDisable(row._id));
	};

	const handleFilterData = (filteredData) => {
		if (typeof filteredData === "string") {
			setSearch(filteredData);
		} else {
			setData(filteredData);
		}
	};

	const mapData = [
		{
			Header: "No",
			width: "20px",
			Cell: ({ index }) => <span>{index + 1}</span>,
		},
		{
			Header: "Image",
			body: "image",
			Cell: ({ row }) => (
				<div>
					{loading ? (
						<Skeleton height={42} width={42} style={{ borderRadius: "90px" }} baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />
					) : (
						<img
							src={row?.image ? getImageUrl(row.image) : "/dummy.png"}
							height={45}
							width={45}
							alt=''
							style={{ borderRadius: "90px", objectFit: "cover" }}
							onError={(e) => {
								e.target.onerror = null;
								e.target.src = "/dummy.png";
							}}
						/>
					)}
				</div>
			),
			sorting: false,
		},
		{
			Header: "Name",
			body: "name",
			Cell: ({ row }) => <span className='fw-normal text-capitalize'>{row.name || "-"}</span>,
		},
		{
			Header: "Email",
			body: "email",
			Cell: ({ row }) => <span className='fw-normal'>{row.email || "-"}</span>,
		},
		{
			Header: "Created Date",
			body: "createdAt",
			Cell: ({ row }) => <span>{dayjs(row.createdAt).format("DD MMM YYYY")}</span>,
		},
		{
			Header: "Status",
			body: "isDisabled",
			Cell: ({ row }) => (
				<span className={`badge ${row.isDisabled ? "bg-danger" : "bg-success"}`} style={{ fontSize: "12px" }}>
					{row.isDisabled ? "Disabled" : "Active"}
				</span>
			),
			sorting: false,
		},
		{
			Header: "Disable",
			body: "",
			Cell: ({ row }) => (
				<div>
					<ToggleSwitch value={row.isDisabled} onClick={() => handleToggle(row)} />
				</div>
			),
			sorting: false,
		},
	];

	return (
		<>
			<div className='mainUserTable'>
				<div className='userTable'>
					<div className='col-12 headname'>Admin Users</div>
					<div className='userMain'>
						<div className='tableMain mt-2'>
							<div className='userHeader primeHeader'>
								<div className='row'>
									<div className='col-2'></div>
									<div className='col-10'>
										<Searching type={`client`} data={adminUsers} setData={setData} column={data} onFilterData={handleFilterData} button={true} setSearchValue={setSearch} searchValue={search} />
									</div>
								</div>
							</div>
							<Table data={data} mapData={mapData} type={"client"} />
						</div>
					</div>
					<div className='userFooter primeFooter'></div>
				</div>
			</div>
		</>
	);
};

export default connect(null, { getAllAdmins, toggleAdminDisable })(AdminUsers);
